<template>
  <section>
    <div class="EtablissementProjetsView-cards">
      <div v-for="project in etablissementProjectsLight" :key="project.id">
        <ProjectCard :project="project" :logged-user="loggedUser" />
      </div>
      <b-message v-if="etablissementProjectsLight.length === 0" type="is-warning">
        {{ $t("etablissementPage.noProjects") }}
      </b-message>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { EtablissementDTO, ProjetAnnuelLightDTO, UtilisateurDTO } from "@/model/bean/GeneratedDTOs"
import { LoginService } from "@/services/rest/login/LoginService"
import { ProjectService } from "@/services/rest/project/ProjectService"
import ProjectCard from "@/views/projects_pp/ProjectCard.vue"
import { BMessage } from "buefy"

export default defineComponent({
  name: "EtablissementProjetsView",
  components: {
    ProjectCard,
    BMessage,
  },
  props: {
    etablissement: {
      type: Object as PropType<EtablissementDTO>,
      required: true,
    },
  },
  data() {
    return {
      loginService: LoginService.INSTANCE,
      projectService: ProjectService.INSTANCE,
      loggedUser: new UtilisateurDTO(),
      etablissementProjectsLight: [] as ProjetAnnuelLightDTO[],
    }
  },
  watch: {
    async etablissement(newVal: EtablissementDTO, oldVal: EtablissementDTO): Promise<void> {
      if (newVal !== oldVal) {
        await this.fetchProjects()
      }
    },
  },
  async created(): Promise<void> {
    await this.fetchProjects()
  },
  methods: {
    async fetchProjects(): Promise<void> {
      const loggedUser = this.loginService.getLoggedUser()
      if (!loggedUser) {
        return
      }
      this.loggedUser = loggedUser
      const projects = await this.projectService.getEtablissementProjects(this.etablissement)
      this.etablissementProjectsLight = projects.map((p) =>
        this.projectService.projetAnnuelToLight(p),
      )
    },
  },
})
</script>

<style lang="scss">
.EtablissementProjetsView-cards {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .ProjectCard {
    margin-left: 0.5rem;
  }
}
</style>
